import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export default function ProjectsModal({proceed, close, projects, checkoutProjects, team}) {
    const [projectOptions, setProjectOptions] = useState(projects || [])
    const [selectedProjects, setSelectedProjects] = useState(checkoutProjects || [])
    const [value, setValue] = useState(null)

    useEffect(() => {
        // clean up dud project ids
        if (projectOptions.length > 0) {
            const presentProjects = selectedProjects.filter(project =>
                projectOptions.some(option => option.id === project.id)
            )
            setSelectedProjects(presentProjects)
        }
    }, [])

    useEffect(() => {
        const data = projects.filter(project =>
            !selectedProjects.some(item => item.id === project.id)
        );
        setProjectOptions(data);
    }, [selectedProjects]);

    const projectData = (id) => {
        let projectArray = projects || []
        let data = projectArray.find(item => item.id === Number(id))
        return data
    }

    const setDefault = (project) => {
        let newData = selectedProjects.map(item => {
            if (item.id === project.id) {
                return {...item, default: !item.default}
            }
            return {...item, default: false}
        })
        setSelectedProjects(newData)
    }

    const deleteProject = (project) => {
        let newList = selectedProjects.filter(item => item.id !== project.id)
        setSelectedProjects(newList)
    }

    const addProject = () => {
        if (value) {
            setSelectedProjects([...selectedProjects, {id: value.id, default: false}])
        }
        setValue(null)
    }

    const truncate = (str, max = 30) => {
        return str?.length > max ? str.slice(0, max) + '...' : str;
    }
  

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
                <h4>Select {team.project_title}</h4>

                {selectedProjects && selectedProjects.map((item) => (
                    <div key={item.id} className='d-flex justify-content-between align-items-center mb-2'>
                        <p>{truncate(projectData(item.id).name)}</p>
                        <button
                            type='button' 
                            className='btn btn-icon d-flex align-items-start' 
                            style={{border: 'none'}}
                        >
                            <i 
                                className={item.default ? `fas fa-check-circle text-primary mr-2` : `far fa-check-circle text-primary mr-2`}
                                onClick={() => setDefault(item)}
                            >
                            </i>
                            <i 
                                className='fa fa-trash text-danger'
                                onClick={() => deleteProject(item)}
                            >
                            </i>
                        </button>
                    </div>
                ))}

                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor='name'>Select {team.project_title}</label>
                            <div className="input-group">
                                 <Select
                                    className="form-control select-groups"
                                    classNamePrefix="select-groups"
                                    onChange={(option) =>
                                        setValue(option)
                                    }
                                    options={projectOptions}
                                    getOptionLabel={option => `${option.name}` }
                                    getOptionValue={option => option.id}
                                    value={value}
                                />
                                <div className="input-group-append">
                                    <button 
                                        className="btn btn-light btn-border" 
                                        type="button" 
                                        onClick={addProject}
                                        disabled={!value}
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-3">
                    <button onClick={() => proceed(selectedProjects)} type="button" className="btn btn-primary mr-2">
                        Proceed
                    </button>

                    <button onClick={() => close()} type="button" className="btn btn-secondary mr-2">
                        Close
                    </button>
                </div>
                <small>Will be shown in the checkout as donation designation options, default will be pre-selected</small>
            </div>
        </div>
    </div>
  )
}
